import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './modules';
import storage from '../components/libs/storage';

// const preloadedState = {
//     login: storage.get('loginStates')?.toJS(),
//     simpleView: storage.get('simpleViewStates')?.toJS()
// };

// 세션스토리지에서 초기 상태 불러오기
function loadState() {
    try {
        const serializedState = sessionStorage.getItem("reduxState");
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        console.error("세션스토리지 불러오기 실패:", e);
        return undefined;
    }
}

// 세션스토리지에 상태 저장 (일부만)
function saveState(state) {
    try {
        const partialState = {
            login: {
                userId: state.login.userId,
                sessionId: state.login.sessionId,
                userRole: state.login.userRole
            },
            simpleView: state.simpleView
        };
        const serializedState = JSON.stringify(partialState);
        sessionStorage.setItem("reduxState", serializedState);
    } catch (e) {
        console.error("세션스토리지 저장 실패:", e);
    }
}

const preloadedState = loadState();

const store = configureStore({
    reducer: rootReducer,
    preloadedState
});

// 상태 변경될 때마다 저장
store.subscribe(() => {
    saveState(store.getState());
});


export default store;
